export default __webpack_public_path__ + "f84b476995a8496adce24ec672244eafc9a43686/a6bf0ad36e700bb31f6714c905f959a1.png";